import { Injectable } from '@angular/core';



export class PasswordValidations {
  lowerCase: boolean;
  upperCase: boolean;
  numberCase: boolean;
  specialCharacterCase: boolean;
  minLengthCase: boolean;

  containsDomain: boolean;
  fName: boolean;
  lName: boolean;
  uName: boolean;


  validateFirstAndLastName = true;
  validateUsername = true;


  isValid() {
    if (this.validateFirstAndLastName)
      return this.lowerCase && this.upperCase && this.numberCase && this.specialCharacterCase && this.minLengthCase && this.containsDomain && this.fName && this.lName && this.uName;
    else
      return this.lowerCase && this.upperCase && this.numberCase && this.specialCharacterCase && this.minLengthCase;
  }


}
@Injectable({ providedIn:'root' })
export class PasswordValidationService {

  constructor() { }


  private reLowerCase = /(?=.*[a-z])/;
  private reUpperCase = /(?=.*[A-Z])/;
  private reNumberCase = /(?=.*\d)/;
  private reSpecialCharacterCase = /(?=(?:.*?[!@#$%*()_+^&}{:;?.]){1})/;
  private reMinLengthCase = /(?=^.{9,}$)/;
  private reEmailCase = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

 


  public validatePassword(password: string, username: string, domain: string, firstName: string, lastName: string, validateFirstAndLastName: boolean, validateUsername: boolean, validateDomain: boolean): PasswordValidations {
    let validations = new PasswordValidations();
    validations.validateFirstAndLastName = validateFirstAndLastName;
    validations.validateUsername = validateUsername;
    validations.lowerCase = this.reLowerCase.test(password);
    validations.upperCase = this.reUpperCase.test(password);
    validations.numberCase = this.reNumberCase.test(password);
    validations.specialCharacterCase = this.reSpecialCharacterCase.test(password);
    validations.minLengthCase = this.reMinLengthCase.test(password);


    if (validateUsername) {

      if (username) {
        let userName = username.toLowerCase();
        userName = userName.indexOf('@') >= 0 ? userName.substr(0, userName.indexOf('@')) : userName;
        validations.uName = password && password.toLowerCase().indexOf(userName) < 0;
      }
    }

    if (validateDomain) {
        validations.containsDomain = password && password.toLowerCase().indexOf(domain) < 0;
    }

    if (validateFirstAndLastName) {
      if (firstName) {
        validations.fName = password
          && password.toLowerCase().indexOf(firstName.toLowerCase()) < 0;
      }
      if (lastName) {
        validations.lName = password
          && password.toLowerCase().indexOf(lastName.toLowerCase()) < 0;
      }


    }

    return validations;
  }
}
